module.exports = __webpack_public_path__ + "img/icon-55.9e6be66b.svg";